/* ==========================================================================
   Prime Organics Honey · PDP v2 · poh.js
   Kaching Bundles proxy engine + shared UI wiring.

   HARD RULE (see SPEC.md §6.1): we NEVER hand-roll /cart/add.js.
   Every add-to-cart proxies the native [id^="ProductSubmitButton-"] submit
   after verifying Kaching has actually selected the bar we want.
   ========================================================================== */
(function () {
  'use strict';

  var POH = (window.POH = window.POH || {});
  var subs = [];

  POH.cfg = null;
  POH.bars = [];
  POH.sel = null;
  POH.ready = false;

  /* ---- config -------------------------------------------------------- */
  POH.opts = window.POH_OPTS || {};
  var baseCents = Number(POH.opts.baseCents || 0);
  var perBox = Number(POH.opts.sachetsPerBox || 10);

  function money(n) {
    return (
      (POH.opts.currencySymbol || '$') +
      Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
  }
  POH.money = money;

  /* ---- kaching readers (proven on this store, see bb8-buybox-v2) ------ */
  function readConfig() {
    var s = document.querySelector('.kaching-bundles-deal-block-settings');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function barPrice(b) {
    if (b.discountType === 'specific' && b.discountValue != null) return b.discountValue;
    if (b.buyDiscountType === 'specific' && b.buyDiscountValue != null) return b.buyDiscountValue;
    if (b.buyDiscountType === 'default' || b.discountType === 'default') {
      var p = (String(b.title || '').match(/\d+/) || [])[0];
      if (p) return parseInt(p, 10) * baseCents / 100;
    }
    return null;
  }

  /* units = sum of the digits in the bar title. Buy1=1, Buy2get1=3, Buy3get2=5 */
  function barUnits(b) {
    return (String(b.title || '').match(/\d+/g) || []).reduce(function (a, n) {
      return a + parseInt(n, 10);
    }, 0) || 1;
  }

  function giftImgById(id) {
    if (!id) return '';
    var t = document.querySelector('.kaching-bundles__free-gift[data-free-gift-id="' + id + '"] .kaching-bundles__free-gift__image');
    return t ? t.src : '';
  }

  function giftValueById(id) {
    if (!id) return 0;
    var t = document.querySelector('.kaching-bundles__free-gift[data-free-gift-id="' + id + '"] .kaching-bundles__free-gift__full-price');
    if (!t) return 0;
    var m = (t.textContent || '').match(/[\d.]+/);
    return m ? parseFloat(m[0]) : 0;
  }

  function titleCase(s) {
    return String(s).toLowerCase().replace(/\b([a-z])/g, function (m, c) { return c.toUpperCase(); });
  }

  function cleanGift(t) {
    t = (t || '').replace(/^\s*\+?\s*/, '');
    var qty = null, m = t.match(/^(\d+)\s*(?:x\s*)?free\s+/i);
    if (m) { qty = parseInt(m[1], 10); t = t.slice(m[0].length); }
    else { t = t.replace(/^free\s+/i, ''); }
    t = titleCase(t.replace(/\s+/g, ' ').trim());
    return qty && qty > 1 ? qty + 'x ' + t : t;
  }
  POH.cleanGift = cleanGift;

  /* ---- bar selection --------------------------------------------------
     Resolve by [data-deal-bar-id] first, then by the quantity parsed out of
     the label. NEVER by radio[value=id] · that silently added the default
     bundle on v4 (SPEC §6.1).
     -------------------------------------------------------------------- */
  function qtyOf(id) {
    var o = ((POH.cfg && POH.cfg.dealBars) || []).filter(function (b) { return b.id === id; })[0];
    if (!o) return null;
    var q = o.buyQuantity || o.quantity || (String(o.title || '').match(/\d+/) || [])[0];
    return q ? Number(q) : null;
  }

  function barElById(id) {
    return document.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + id + '"]') ||
           document.querySelector('[data-deal-bar-id="' + id + '"]');
  }

  function barElByQty(q) {
    if (q == null) return null;
    var bs = document.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id],[data-deal-bar-id]');
    for (var i = 0; i < bs.length; i++) {
      var m = (bs[i].innerText || '').match(/(\d+)/);
      if (m && Number(m[1]) === q) return bs[i];
    }
    return null;
  }

  function selectBarNative(id) {
    var b = barElById(id) || barElByQty(qtyOf(id));
    if (b) {
      var r = b.querySelector('input[type="radio"]');
      if (r) { if (!r.checked) r.click(); } else { b.click(); }
      return true;
    }
    var rr = document.querySelector('input.kaching-bundles__bar-radio[value="' + id + '"]');
    if (rr) { if (!rr.checked) rr.click(); return true; }
    return false;
  }

  function currentBar() {
    var sb = document.querySelector('.kaching-bundles__bar--selected[data-deal-bar-id]');
    if (sb) return sb.getAttribute('data-deal-bar-id');
    var r = document.querySelector('input.kaching-bundles__bar-radio:checked');
    if (r) {
      var pb = r.closest && r.closest('[data-deal-bar-id]');
      if (pb) return pb.getAttribute('data-deal-bar-id');
      return r.value;
    }
    return null;
  }

  function nativeATC() {
    return document.querySelector('[id^="ProductSubmitButton-"]') ||
           document.querySelector('form[action*="/cart/add"] [type="submit"]') ||
           document.querySelector('button[name="add"]');
  }

  /* ---- public model ---------------------------------------------------- */
  function decorate(b) {
    var units = barUnits(b.b);
    var compare = baseCents / 100 * units;
    var save = compare > b.price ? Math.round((1 - b.price / compare) * 100) : 0;
    var nights = units * perBox;
    var gifts = (b.b.freeGifts || []).map(function (g) {
      return { id: g.id, name: cleanGift(g.text), value: giftValueById(g.id), img: giftImgById(g.id) };
    });
    var giftTotal = gifts.reduce(function (a, g) { return a + (g.value || 0); }, 0);
    return {
      id: b.id,
      raw: b.b,
      title: b.b.title || '',
      price: b.price,
      units: units,
      compare: compare,
      save: save,
      nights: nights,
      perNight: nights ? b.price / nights : 0,
      perBox: units ? b.price / units : b.price,
      gifts: gifts,
      giftTotal: giftTotal
    };
  }

  POH.list = function () { return POH.bars.map(decorate); };
  POH.selected = function () {
    var m = POH.bars.filter(function (b) { return b.id === POH.sel; })[0];
    return m ? decorate(m) : null;
  };

  POH.pick = function (id) {
    POH.sel = id;
    selectBarNative(id);
    emit();
  };

  /* verify-loop before firing: currentBar() must equal our selection */
  POH.addToCart = function () {
    if (!POH.sel) { var nb0 = nativeATC(); if (nb0) nb0.click(); return; }
    selectBarNative(POH.sel);
    var tries = 0;
    (function go() {
      if (currentBar() === POH.sel || tries >= 6) {
        var btn = nativeATC();
        if (btn) btn.click();
        return;
      }
      tries++;
      selectBarNative(POH.sel);
      setTimeout(go, 80);
    })();
  };

  POH.onChange = function (fn) { subs.push(fn); if (POH.ready) fn(); };
  function emit() { subs.forEach(function (fn) { try { fn(); } catch (e) {} }); }

  /* ---- boot ------------------------------------------------------------ */
  function activate() {
    if (POH.ready) return true;
    var cfg = readConfig();
    if (!cfg || !cfg.dealBars || !cfg.dealBars.length) return false;
    if (!document.querySelector('[class*="kaching-bundles__bars"]')) return false;

    var bars = cfg.dealBars.map(function (b) {
      var p = barPrice(b);
      return p == null ? null : { id: b.id, b: b, price: p };
    }).filter(Boolean);
    if (!bars.length) return false;

    POH.cfg = cfg;
    POH.bars = bars;
    POH.sel = currentBar() || cfg.preselectedDealBarId || bars[0].id;
    if (!bars.some(function (x) { return x.id === POH.sel; })) POH.sel = bars[0].id;
    selectBarNative(POH.sel);

    POH.ready = true;
    document.body.classList.add('poh-ready');
    emit();
    return true;
  }

  var tries = 0;
  var iv = setInterval(function () { if (activate() || ++tries > 40) clearInterval(iv); }, 350);
  document.addEventListener('DOMContentLoaded', activate);

  /* keep in sync if Kaching re-renders or is changed elsewhere */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('kaching-bundles__bar-radio')) {
      var v = currentBar();
      if (v && v !== POH.sel && POH.bars.some(function (x) { return x.id === v; })) {
        POH.sel = v; emit();
      }
    }
  });

  /* ======================================================================
     Shared UI wiring
     ====================================================================== */
  document.addEventListener('click', function (e) {
    /* any CTA anywhere on the page */
    var cta = e.target.closest && e.target.closest('[data-poh-atc]');
    if (cta) { e.preventDefault(); POH.addToCart(); return; }

    /* tier selection */
    var tier = e.target.closest && e.target.closest('[data-poh-bar]');
    if (tier) { e.preventDefault(); POH.pick(tier.getAttribute('data-poh-bar')); return; }

    /* scroll to the buybox */
    var jump = e.target.closest && e.target.closest('[data-poh-jump]');
    if (jump) {
      e.preventDefault();
      var t = document.getElementById('poh-buybox');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* FAQ cards · colour swap, never a height change */
    var fq = e.target.closest && e.target.closest('[data-poh-faq]');
    if (fq) {
      var open = fq.classList.contains('is-open');
      var grid = fq.closest('.poh-faq__grid');
      if (grid) {
        grid.querySelectorAll('.poh-faq__card').forEach(function (c) {
          c.classList.remove('is-open');
          c.setAttribute('aria-expanded', 'false');
        });
      }
      if (!open) { fq.classList.add('is-open'); fq.setAttribute('aria-expanded', 'true'); }
      return;
    }

    /* gallery */
    var gp = e.target.closest && e.target.closest('[data-poh-gal]');
    if (gp) { gallery(gp.getAttribute('data-poh-gal')); return; }
  });

  /* ---- gallery --------------------------------------------------------- */
  function gallery(dir) {
    var stage = document.querySelector('.poh-gal__stage');
    if (!stage) return;
    var slides = [].slice.call(stage.querySelectorAll('.poh-gal__slide'));
    if (!slides.length) return;
    var cur = slides.findIndex(function (s) { return s.classList.contains('is-on'); });
    if (cur < 0) cur = 0;
    var next = dir === 'prev' ? (cur - 1 + slides.length) % slides.length
             : dir === 'next' ? (cur + 1) % slides.length
             : parseInt(dir, 10) || 0;
    slides.forEach(function (s, i) { s.classList.toggle('is-on', i === next); });
    document.querySelectorAll('.poh-gal__thumb').forEach(function (t, i) {
      t.setAttribute('aria-current', i === next ? 'true' : 'false');
    });
  }

  /* ---- collapse the review badge slot when nothing paints into it --------
     Judge.me's badge does not install on this template, leaving an empty box
     that pushed everything below it down. Measured, not assumed: the slot
     only survives if it actually has painted height. */
  function badgeSlot() {
    var slot = document.querySelector('.poh-bb__rating');
    if (!slot) return;
    function check() {
      /* measure, do not infer: the badge ships markup with hidden svgs inside,
         so "contains an element" reports painted when nothing is drawn.
         Height is the only honest signal. */
      slot.classList.remove('is-empty');
      var h = slot.getBoundingClientRect().height;
      slot.classList.toggle('is-empty', h < 6);
    }
    check();
    var n = 0, iv = setInterval(function () { check(); if (++n > 12) clearInterval(iv); }, 400);
  }
  if (document.readyState !== 'loading') badgeSlot();
  else document.addEventListener('DOMContentLoaded', badgeSlot);

  /* ---- header dressing --------------------------------------------------
     Both bars go INSIDE <sticky-header>, so the theme's own sticky logic
     carries them and we never add a competing fixed element. Every line here
     is copy that already exists on the page, quoted as written · nothing in
     the header may introduce a claim the page does not already make (§7.1).
     The header itself is sitewide, so the styling is scoped to body.poh-on
     and the real PDP keeps the black header (scope flag S1). */
  var TOPBAR_LINES = [
    'Free US shipping over $50',
    'Ships discreetly in plain outer packaging',
    'Money-back guarantee'
  ];
  var TRUST_ITEMS = ['Secure checkout', 'Ships discreetly', 'Money-back guarantee'];

  function headerDress() {
    var host = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (!host || host.querySelector('.poh-topbar')) return;

    var top = document.createElement('div');
    top.className = 'poh poh-topbar';
    top.setAttribute('role', 'status');
    TOPBAR_LINES.forEach(function (t, i) {
      var s = document.createElement('span');
      s.className = 'poh-topbar__line' + (i === 0 ? ' is-on' : '');
      s.textContent = t;
      top.appendChild(s);
    });
    host.insertBefore(top, host.firstChild);

    var trust = document.createElement('div');
    trust.className = 'poh poh-htrust';
    TRUST_ITEMS.forEach(function (t) {
      var s = document.createElement('span');
      s.textContent = t;
      trust.appendChild(s);
    });
    host.appendChild(trust);

    /* the header is fixed on our templates (see the note in poh-v2.css), so
       the body has to be pushed down by exactly its height, bars included */
    function measure() {
      var sec = document.querySelector('.section-header');
      if (!sec) return;
      var h = Math.round(sec.getBoundingClientRect().height);
      if (h) document.documentElement.style.setProperty('--poh-hdr-h', h + 'px');
    }
    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('load', measure);
    var mt;
    window.addEventListener('resize', function () { clearTimeout(mt); mt = setTimeout(measure, 150); });

    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (still || TOPBAR_LINES.length < 2) return;
    var lines = top.querySelectorAll('.poh-topbar__line');
    var at = 0;
    setInterval(function () {
      lines[at].classList.remove('is-on');
      at = (at + 1) % lines.length;
      lines[at].classList.add('is-on');
    }, 4200);
  }
  if (document.readyState !== 'loading') headerDress();
  else document.addEventListener('DOMContentLoaded', headerDress);

  /* ---- scrolling strips -------------------------------------------------
     A marquee loops seamlessly only if the shift equals exactly one repeat
     unit AND the track still covers the container after that shift. The
     hand-written 2 copies + translateX(-50%) satisfied neither: at 1440px it
     left a 570px blank tail and jumped 17px (half the old flex gap) per cycle.
     Copy count depends on the rendered text width, which only the browser
     knows, so it is decided here and handed back to CSS as a percentage.
     SPEC.md §5.8, trap 12. */
  function stripLayout(strip) {
    var track = strip.querySelector('.poh-strip__track');
    if (!track) return;
    if (!track.pohProto) {
      var seed = track.firstElementChild;
      if (!seed) return;
      track.pohProto = seed.cloneNode(true);
    }
    /* measure ONE copy alone, otherwise the count feeds back into itself */
    track.textContent = '';
    track.appendChild(track.pohProto.cloneNode(true));
    var unitW = track.firstElementChild.getBoundingClientRect().width;
    if (!unitW) return;

    var containerW = strip.getBoundingClientRect().width;
    /* after shifting one unit, (n-1) units must still span the container */
    var n = Math.max(2, Math.ceil(containerW / unitW) + 1);
    for (var i = 1; i < n; i++) track.appendChild(track.pohProto.cloneNode(true));

    track.style.setProperty('--poh-strip-shift', (-100 / n).toFixed(4) + '%');
    var speed = parseFloat(getComputedStyle(track).getPropertyValue('--poh-strip-speed')) || 24;
    track.style.animationDuration = (unitW / speed).toFixed(2) + 's';
  }

  function stripInit() {
    var strips = [].slice.call(document.querySelectorAll('.poh-strip'));
    if (!strips.length) return;
    function layoutAll() { strips.forEach(stripLayout); }
    layoutAll();
    /* webfonts land after first paint and change every width */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layoutAll);
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(layoutAll, 150);
    });
  }
  if (document.readyState !== 'loading') stripInit();
  else document.addEventListener('DOMContentLoaded', stripInit);

  /* ---- sticky bar contents ----------------------------------------------
     The bar mirrors the Kaching selection both ways: the select writes to
     POH.pick, and POH.onChange writes back, so changing the tier in the
     buybox moves the bar and vice versa. The anchor is units x the single
     box price, the same "bought separately" number the buybox uses, never a
     compare_at (the product has none). */
  function stickyBind() {
    var bar = document.querySelector('.poh-sticky');
    if (!bar) return;
    var sel = bar.querySelector('[data-poh-sticky-tier]');
    var was = bar.querySelector('[data-poh-sticky-was]');
    var now = bar.querySelector('[data-poh-sticky-now]');

    if (sel) {
      sel.addEventListener('change', function () { POH.pick(sel.value); });
    }

    function fill() {
      var list = POH.list();
      if (!list.length) return;
      if (sel && sel.options.length !== list.length) {
        sel.textContent = '';
        list.forEach(function (b) {
          var o = document.createElement('option');
          o.value = b.id;
          o.textContent = b.title;
          sel.appendChild(o);
        });
      }
      var s = POH.selected();
      if (!s) return;
      if (sel) sel.value = s.id;
      if (was) was.textContent = s.compare > s.price ? money(s.compare) : '';
      if (now) now.textContent = money(s.price);
    }

    POH.onChange(fill);
    fill();
  }
  if (document.readyState !== 'loading') stickyBind();
  else document.addEventListener('DOMContentLoaded', stickyBind);

  /* ---- sticky ATC reveal ----------------------------------------------- */
  function stickyInit() {
    var bar = document.querySelector('.poh-sticky');
    if (!bar) return;
    var anchor = document.getElementById('poh-buybox');
    function tick() {
      var past = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      var atEnd = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 260);
      bar.classList.toggle('is-on', past && !atEnd);
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }
  if (document.readyState !== 'loading') stickyInit();
  else document.addEventListener('DOMContentLoaded', stickyInit);
})();
